import {
  MultiEmail,
  MultiEmailTag,
} from '@synoptic/ui-kit/multi-email/multi-email.tsx';
import { FC } from 'react';
import { Control, Controller, FormState } from 'react-hook-form';
import { subTitle } from '@/components/streams/stream-invite/invite-users-modal.css.ts';
import { InviteUsersFormData } from '@/components/streams/stream-invite/invite-users-modal.tsx';

export const InviteByEmailModalContent: FC<{
  control: Control<InviteUsersFormData>;
  formState: FormState<InviteUsersFormData>;
  maxInvites: number;
}> = ({ control, formState, maxInvites }) => {
  return (
    <>
      <div className={subTitle}>
        Type emails of those who you want to invite to your private stream.
        Press enter to invite multiple emails. You can remove invited users
        later if you want.
      </div>

      <Controller
        name="emails"
        control={control}
        rules={{
          required: 'This field is required',
          validate: (value) => {
            return value.length > maxInvites
              ? `You can only add up to ${maxInvites} streams to a list`
              : true;
          },
        }}
        render={({ field }) => {
          return (
            <MultiEmail
              emails={field.value}
              onChange={(emails) => {
                field.onChange(emails);
              }}
              getLabel={(email, index, removeEmail) => {
                return (
                  <MultiEmailTag
                    key={index}
                    removeEmail={() => removeEmail(index)}
                  >
                    {email}
                  </MultiEmailTag>
                );
              }}
              label={'Email'}
              errorMessage={formState.errors.emails?.message}
            />
          );
        }}
      />
    </>
  );
};
